<template>
  <v-card outlined class="mb-5 pl-2" color="grey lighten-4">
    <v-card-text class="pt-2 pb-0">
      <span class="body-2"
        ><v-icon class="mr-1 mb-1" small>fas fa-edit</v-icon> BATCH EDIT:
        <span v-if="releaseNoteSearchIsLoading"
          ><v-icon class="spinner mx-3" size="15">fa fa-spinner</v-icon></span
        ></span
      >
      <v-row justify-end>
        <v-col sm="12" md="4">
          <dynamic-dropdown
            :disabled="batchEditIsDisabled"
            :multiple="false"
            @input="handlePrimaryActivityChange"
            attributeName="primaryActivityDropdownValueId"
            data-cy="batchEdit-primaryActivity-dropdown"
            v-model="primaryActivityDropdownValueIdSelected"
          ></dynamic-dropdown
        ></v-col>
      </v-row>
    </v-card-text>
    <v-dialog v-model="primaryActivityDialog" min-width="800" scrollable persistent>
      <batch-edit-confirmation
        :edited-field="attributeToEdit"
        :secondary-selected-value="getApplicationLabel('primaryActivityDropdownValueIdSelected')"
        :selected-items="selectedItems"
        :selected-value="getPrimaryActivityLabel('primaryActivityDropdownValueIdSelected')"
        @cancelBatchEdit="cancelBatchEdit('primaryActivityDropdownValueIdSelected')"
        @setDialog="setPrimaryActivityDialog"
        @submitBatchEdit="submitBatchEdit('primaryActivityDropdownValueIdSelected')"
        secondary-selected-field-display-text="Application"
        selected-field-display-text="Primary Activity"
      ></batch-edit-confirmation>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import BatchEditConfirmation from "./BatchEditConfirmation";
import DynamicDropdown from "@/components/DynamicDropdown";

export default {
  components: { BatchEditConfirmation, DynamicDropdown },
  computed: {
    batchEditIsDisabled() {
      return !this.selectedItems.length || this.releaseNoteSearchIsLoading;
    },
    ...mapState({
      releaseNoteSearchIsLoading: state => state.releaseNote.isLoadingReleaseNoteSearch,
    }),
    ...mapGetters({
      getDropdownValueFromValueList: "admin/dropdown/getDropdownValueFromValueList",
    }),
  },
  data() {
    return {
      attributeToEdit: null,
      primaryActivityDialog: false,
      primaryActivityDropdownValueIdSelected: null,
      primaryActivityDropdownValueLabelSelected: "",
      primaryActivityValue: {},
    };
  },
  methods: {
    async cancelBatchEdit(value) {
      this[`${value}`] = null;
      this.attributeToEdit = null;
    },
    getPrimaryActivityLabel(value) {
      const batchEditValue = this[`${value}`];
      return this.getDropdownValueFromValueList(batchEditValue).label;
    },
    getApplicationLabel(value) {
      const batchEditValue = this[`${value}`];

      const primaryActivity = this.getDropdownValueFromValueList(batchEditValue);
      return this.getDropdownValueFromValueList(primaryActivity.groupDropdownValueId).label;
    },
    handlePrimaryActivityChange(val) {
      if (val) {
        this.attributeToEdit = "primaryActivityDropdownValueId";
        this.primaryActivityDialog = true;
      }
    },
    async submitBatchEdit(value) {
      const batchEditValue = this[`${value}`];

      let edits = {};

      if (this.attributeToEdit === "primaryActivityDropdownValueId") {
        const dropdownValue = this.getDropdownValueFromValueList(batchEditValue);
        const applicationDropdownValueId = dropdownValue.groupDropdownValueId;
        edits = Object.assign(
          {},
          {
            primaryActivityDropdownValueId: batchEditValue,
            applicationDropdownValueId,
          }
        );
      }

      const data = this.selectedItems.map(item => {
        return {
          id: item.id,
          ...edits,
        };
      });

      try {
        await this.batchEdit({ data });
        this.$notifySuccess(`Successfully edited ${this.selectedItems.length} records`);
      } catch (e) {
        console.error(e);
        return this.$notifyError("Error submitting batch edit");
      }

      this.updateReleaseNoteEditSelectionList([]);
      this.$emit("refreshList");
      this[`${value}`] = null;
      this.attributeToEdit = null;
    },

    setPrimaryActivityDialog(val) {
      this.primaryActivityDialog = val;
    },
    ...mapActions({
      batchEdit: "releaseNote/batchEditReleaseNote",
      fetchDropdownValueList: "admin/dropdownValue/list",
    }),
    ...mapMutations({
      updateReleaseNoteEditSelectionList: "releaseNote/setReleaseNoteBatchEditSelectionList",
    }),
  },
  props: {
    selectedItems: {
      type: Array,
      default: [],
    },
  },
};
</script>
